import { render } from "./templateMomoFinal.vue?vue&type=template&id=0225ba24&scoped=true"
import script from "./templateMomoFinal.vue?vue&type=script&lang=js"
export * from "./templateMomoFinal.vue?vue&type=script&lang=js"

import "./templateMomoFinal.vue?vue&type=style&index=0&id=0225ba24&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0225ba24"]])

export default __exports__